module.exports = __webpack_public_path__ + "static/media/escudoMuni.08cb8e07.png";